export default (Vue) => {
  Vue.directive("autocomplete", {//禁止表单自动填充
    inserted: function(el, binding, vnode, oldVnode) {
    	el.setAttribute("readonly","readonly");
		setTimeout(function removeReadonly(){
			el.removeAttribute("readonly");
		},1000);
    }
  })
}



// WEBPACK FOOTER //
// ./src/core/directive/directive.js